import Config from 'Config';

import { createApiClient } from '../api-client-factory';

import { FeatureFlagsResponse } from './types';

const client = createApiClient(`${Config.text_api_url}/feature-control/v1/features/accounts`);

/**
 * Feature flags API client.
 */
export const featureFlagsClient = {
  /**
   * Retrieves my inactivity.
   */
  get: async (token: string) => client.get<FeatureFlagsResponse>('', token, {}, false),
};
